@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/spacers';
@import '@helsenorge/designsystem-react/scss/breakpoints';

.temavalg-button {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    outline: none;

    .temavalg-button__icon {
      background-color: #fde8cc;
      transform: scale(102%);
      outline: 0.18rem solid #ffefda;
      outline-offset: -1px;

      svg {
        transform: scale(105%) translateY(-2%);
      }
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgb(255 255 255 / 38%) 0%, rgb(255 236 211 / 58%) 42.71%, rgb(255 229 194 / 81%) 89.06%);
    min-width: 14.375rem;
    min-height: 14.375rem;
    box-shadow: 1px 2px 4px #0000003f;
    border-radius: 10rem;
    border: none;
    transition:
      transform 0.5s ease-in-out,
      background-color 0.5s ease-in-out,
      outline 0.5s ease-in-out;

    @media (max-width: map.get($grid-breakpoints, md)) {
      min-width: 110px;
      min-height: 110px;
    }

    svg {
      transition: transform 0.5s ease-in-out;
    }
  }

  &__text {
    position: relative;
    padding: 0;
    margin: 0;
    font-family: Avenir, Montserrat, Poppins, serif;
    font-weight: 500;
    font-size: 30px;
    max-width: 14.375rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      line-height: 1.18rem;
      font-size: 23px;
      padding-left: 1rem;
      text-align: left;
    }
  }

  color: #fbebd3;
  text-decoration: underline;

  &--quiz {
    color: #85fffb;
    text-decoration: underline;
  }

  &:focus,
  &:hover {
    color: #fff;
    text-decoration: none;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    display: inline-flex;
    flex-direction: row;
    justify-content: left;
    width: 100%;
  }
}
